module.exports = __webpack_public_path__ + "img/1.a0b59c49.jpg";